export default __webpack_public_path__ + "static/media/cakes.c2a0814b.jpg";